import type { Post } from "@/lib/blog/getPost";

// Generate the object-position style based on focal point if available
export const getFocalPointStyle = (post: Post) => {
  if (post.imageFocalPoint) {
    const { x, y } = post.imageFocalPoint;
    return { objectPosition: `${x}% ${y}%` };
  }
  return {};
};

// Helper function to format dates in an SSR-friendly way
export const formatDate = (date: Date | string): string => {
  const d = date instanceof Date ? date : new Date(date);

  // Check if date is valid before formatting
  if (Number.isNaN(d.getTime())) {
    return "Invalid date";
  }

  try {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(d);
  } catch (e) {
    // Fallback formatting if Intl API fails
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  }
};
